// This component assumes it is rendered in a grid

import { Box, Button, Flex, FlexProps, GridItem, Image, Spacer, Text } from "@chakra-ui/react";

import { RightArrowIcon } from "../../icons";

import { RanaHeading } from "./rana-heading";

interface RanaCardProps extends FlexProps {
  imageSrc?: string;
  gridItemHeight: string;
  title: string;
  shortDescription: string;
  buttonText: string;
}

export function RanaCard({
  gridItemHeight,
  imageSrc,
  title,
  shortDescription,
  buttonText,
  onClick,
  ...rest
}: RanaCardProps) {
  return (
    <GridItem as={Button} variant="listitem" onClick={onClick} h={gridItemHeight}>
      <Flex
        h="full"
        w="full"
        overflow="hidden"
        color="brand.deep_sea"
        rounded="base"
        flexDir="column"
        p={2}
        pb={4}
        {...rest}
      >
        <Box
          flexShrink={0}
          w="full"
          h={`calc(${gridItemHeight} / 2)`}
          rounded="base"
          overflow="hidden"
          bg={imageSrc ? undefined : "brand.grey.300"}
          mb={2}
        >
          {imageSrc && (
            <Image w="full" h="full" objectFit="cover" objectPosition="center" src={imageSrc} />
          )}
        </Box>
        <RanaHeading flexShrink={0} type="h4">
          {title}
        </RanaHeading>

        <Text fontSize="sm" fontWeight="normal" overflow="auto">
          {shortDescription}
        </Text>
        <Spacer />
        <Button
          as="div"
          ml="auto"
          mt={2}
          flexShrink={0}
          h="fit"
          variant="fourhtiary"
          rightIcon={<RightArrowIcon />}
          color="brand.analytic"
        >
          {buttonText}
        </Button>
      </Flex>
    </GridItem>
  );
}
